import { MODALITY, STATUS } from "../consts";

export const getStatus = (status, translate = false) => {
    const names = {
        [STATUS.RECEIVED]: translate ? "recebido" : "received",
        [STATUS.TO_BE_RECEIVED]: translate ? "a receber" : "receive",
        [STATUS.CANCELED]: translate ? "cancelado" : "canceled",
        [STATUS.RESALE]: translate ? "pago em outra negociação" : "resale",
        [STATUS.SUSPENDED]: translate ? "suspenso" : "suspended",
        [STATUS.FROZEN_PAYMENT]: translate ? "congelado" : "frozen",
        [STATUS.BANK_DATA_DIVERGENCE]: translate ? "divergência nos dados bancários" : "bank-data-divergence",
        [STATUS.ANALYSIS]: translate ? "em análise" : "analysis"
    };
    return names[status] || "";
}

export 	const getIcon = (status) => {
    const icons = {
        [STATUS.RECEIVED]: "icon-max-communication-circle-check",
        [STATUS.TO_BE_RECEIVED]: "icon-clock",
        [STATUS.CANCELED]: "icon-max-communication-circle-close",
        [STATUS.RESALE]: "icon-max-communication-circle-close",
        [STATUS.FROZEN_PAYMENT]: "icon-max-action-lock",
        [STATUS.BANK_DATA_DIVERGENCE]: "icon-attention",
        [STATUS.ANALYSIS]: "icon-credit-card-search-loupe"
    };
    return icons[status] || "";
}

export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

export const isForwardPayment = (modality, transaction) => modality === MODALITY.SCHEDULED && transaction === 1;
export const isResale =  (status) => status === STATUS.RESALE;
export const isFrozenPayment =  (status) => status === STATUS.FROZEN_PAYMENT;